import React, { useState } from 'react';
import { FaUserCircle, FaChevronDown, FaCrown, FaBars, FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const Navbar = ({ userData }) => {
  const showUserData = userData && userData.name && userData.email;
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <nav className="bg-blue-500 fixed w-full z-30 top-0 shadow-sm">
      <div className="px-4 sm:px-6 lg:px-8 py-2">
        <div className="relative flex items-center justify-between h-14">
          {/* Logo Section */}
          <div className="flex items-center flex-shrink-0 ml-0 sm:ml-8 md:ml-12 lg:ml-16">
            <div className="flex flex-col">
              <span className="text-lg sm:text-xl lg:text-2xl font-bold text-white tracking-tight">Linkforce AI</span>
              <div className="flex items-center">
                <span className="text-xs text-blue-100">by</span>
                <a 
                  href="https://curosai.com" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-xs text-blue-100 hover:text-white ml-1 underline decoration-dotted"
                >
                  CurosAI
                </a>
              </div>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center lg:hidden">
            {/* Mobile menu toggle */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-white hover:bg-blue-600 focus:outline-none"
            >
              {isMobileMenuOpen ? (
                <FaTimes className="h-6 w-6" />
              ) : (
                <FaBars className="h-6 w-6" />
              )}
            </button>
          </div>

          {/* Desktop menu */}
          <div className="hidden lg:flex lg:items-center lg:space-x-4">
            <button className="flex items-center text-sm p-1.5 rounded-lg hover:bg-blue-600 transition-colors">
              <FaUserCircle className="w-7 h-7 text-white opacity-90" />
              <div className="ml-3 text-left">
                <div className="text-sm font-medium text-white">
                  {showUserData ? userData.name : ''}
                </div>
                <div className="text-xs text-blue-50 opacity-90">
                  {showUserData ? userData.email : ''}
                </div>
              </div>
              <FaChevronDown className="ml-2 text-blue-50 opacity-75 w-3 h-3" />
            </button>
          </div>
        </div>

        {/* Mobile menu dropdown */}
        <div className={`lg:hidden ${isMobileMenuOpen ? 'block' : 'hidden'}`}>
          <div className="pt-2 pb-3 space-y-1 border-t border-blue-400/30">
            {showUserData && (
              <div className="px-3 py-2 rounded-md text-white hover:bg-blue-600 transition-colors">
                <div className="flex items-center">
                  <FaUserCircle className="w-6 h-6 text-white opacity-90" />
                  <div className="ml-3">
                    <div className="text-sm font-medium">{userData.name}</div>
                    <div className="text-xs opacity-90">{userData.email}</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-gradient {
          animation: gradient 3s ease infinite;
          background-size: 200% 200%;
        }
        .group:hover {
          background-position: right center;
        }
      `}</style>
    </nav>
  );
};

export default Navbar;